import React from 'react';
import { Vertical } from './social-share';

export function VerticalGrey(props) {
  return <Vertical grey {...props} />;
}